import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PendingApproval from './PendingApproval';

function ProtectedRoute({ children }) {
    const { isAuthenticated, isApproved, isPending, isBlocked, loading } = useAuth();

    if (loading) {
        return (
            <div className="loading">
                <div className="spinner"></div>
                <span>Carregando...</span>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (isPending) {
        return <PendingApproval />;
    }

    if (isBlocked) {
        return (
            <div className="login-page">
                <div className="login-card">
                    <div className="login-logo">
                        <span className="login-logo-icon" style={{ color: '#ef4444' }}>&#10007;</span>
                        <h1>Acesso Bloqueado</h1>
                        <p>Sua conta foi bloqueada pelo administrador.</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!isApproved) {
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default ProtectedRoute;
